<template>
  <section v-if="items.length">
    <v-container>
      <div class="justify-center grid-list">
        <StudentMenuCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import StudentMenuCard from "../cards/StudentMenuCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "student",
  path: "/aluno",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod)
        .list.filter(({ icon, title }) => !!icon && !!title)
        .map(({ icon, attachments, title, text }) => {
          const item = {
            img: icon,
            title,
          };

          if (text || attachments.length > 1)
            item.to = `${_config.path}/${formatToURL(title)}`;
          else item.to = this.server + attachments[0].path;

          return item;
        });
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    StudentMenuCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;

  @media screen and (max-width: 959.9px) {
    gap: 12px;
  }

  @media screen and (max-width: 599.9px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 210px));
  }
}
</style>
